import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FileSaver from 'file-saver';
import { getHalykLink, getInvoice } from 'redux/modules/auth';

class SubscribeModal extends Component {
  static propTypes = {
    history: PropTypes.objectOf(PropTypes.any),
    modalInnerType: PropTypes.string,
    modalType: PropTypes.string,
    tariff: PropTypes.array,
    onCloseClick: PropTypes.func,
    getHalykLink: PropTypes.func,
    getInvoice: PropTypes.func,
    user: PropTypes.shape({
      email: PropTypes.string
    })
  };
  state = {
    invoiceData: false,
    invoiceBin: '',
    invoiceCompany: '',
    invoiceAddress: '',
    invoiceContact: '',
    tariff: this.props.modalInnerType,
    payLink: '',
    error: false,
    load: false
  }
  getLink = () => {
    this.props.getHalykLink(this.props.modalType, this.state.tariff).then(res => {
      if (res.status === 'success') {
        halyk.pay({
          invoiceId: res.orderId,
          backLink: `https://mvoter.com/pay/check/${res.orderId}`,
          failureBackLink: "https://mvoter.com/tariffs",
          postLink: "https://api.mvoter.com/v1/pay/halykbank",
          failurePostLink: "https://api.mvoter.com/v1/pay/halykbank",
          language: "RU",
          description: "Upgrade tariff",
          accountId: "MVOTER.COM",
          terminal: "a989415c-26f8-4123-b2ee-eb54d70da2b6",
          amount: res.amount,
          currency: "KZT",
          phone: "77780514057",
          email: "support@mvoter.com",
          cardSave: false,
          auth: res.accessToken
        });
      }
    }).catch(err => {
      if (err.message === 'Unauthorized') {
        this.props.history.push('/login?subId=register');
      }
    });
  }
  getInvoices = () => {
    if (this.state.invoiceBin === '' || this.state.invoiceCompany === '' || this.state.invoiceAddress === '' || this.state.invoiceContact === '') {
      this.setState({ error: true, load: false });
      return ;
    } else {
      this.setState({ error: false, load: true });
    }
    if (!this.state.load) {
      this.props.getInvoice(this.state.invoiceBin, this.state.invoiceCompany, this.state.invoiceAddress, this.state.invoiceContact, this.props.modalType, this.state.tariff).then(res => {
        FileSaver.saveAs(`https://api.mvoter.com/static/download/${res.source}`);
        this.setState({ error: false, load: false });
        this.props.onCloseClick();
      });
    }
  };
  componentDidMount() {
    this.setState({ invoiceContact: this.props.user ? this.props.user.phone : '' });
  }
  render() {
    const styles = require('./SubscribeModal.less');

    if (this.state.payLink !== '') {
      return (
        <div className={ styles.sub } style={{ height: '590px' }}>
          <iframe src={ this.state.payLink } width="100%" height="100%" />
        </div>
      )
    }

    if (this.props.modalType == 'BASIC' || this.props.modalType == 'STANDARD' ||
        this.props.modalType == 'PREMIUM' || this.props.modalType == 'ELITE') {
      return (
        <div className={ styles.sub }>
          <p>Выберите вид подписки</p>
          <div className={ styles.subscribe }>
            <div onClick={ () => this.setState({ tariff: 'year' }) } className={`${ styles.select } ${ this.state.tariff === 'year' ? styles.selected : '' }`}>
              <span>Ежегодная подписка. Экономия – 30%!</span>
              <span>${ this.props.tariff[0].price } / { this.props.tariff[0].label }</span>
            </div>
            {/* <div onClick={ () => this.setState({ tariff: 'month' }) } className={`${ styles.select } ${ this.state.tariff === 'month' ? styles.selected : '' }`}>
              <span>Месячная подписка</span>
              <span>${ this.props.tariff[1].price } / { this.props.tariff[1].label }</span>
            </div> */}
          </div>
          <div className={ styles.price }>
            <span>Цена</span>
            <span>{ `$${ this.state.tariff === 'year' ? this.props.tariff[0].price : this.props.tariff[1].price } за 1 ${ this.state.tariff === 'year' ? this.props.tariff[0].label : this.props.tariff[1].label }` }</span>
          </div>
          <h4 style={{ textDecoration: 'underline', fontSize: '14px!important', marginTop: '20px', fontWeight: '300', textAlign: 'left', cursor: 'pointer' }} onClick={ () => this.setState({ invoiceData: !this.state.invoiceData, error: false }) }>Выставить счет на оплату для юридических лиц (банковский перевод)</h4>
          { this.state.invoiceData &&
            <div className={ styles.subscribe } style={{ marginBottom: '10px' }}>
              <div><input style={{ fontSize: '12px', height: '30px' }} type="text" onBlur={ e => this.setState({ invoiceBin: e.target.value }) } placeholder="БИН / ИИН" maxLength="12" /></div>
              <div><input style={{ fontSize: '12px', height: '30px' }} type="text" onBlur={ e => this.setState({ invoiceCompany: e.target.value }) } placeholder="Юридическое наименование компании" maxLength="50" /></div>
              <div><input style={{ fontSize: '12px', height: '30px' }} type="text" onBlur={ e => this.setState({ invoiceAddress: e.target.value }) } placeholder="Адрес" maxLength="40" /></div>
              <div><input style={{ fontSize: '12px', height: '30px' }} type="text" onBlur={ e => this.setState({ invoiceContact: e.target.value }) } placeholder="Контактный телефон" maxLength="11" defaultValue={ this.state.invoiceContact } /></div>
            </div>
          }
          { this.state.error && 
            <p style={{ color: '#e97b7b' }}>Все поля обязательные для заполнения</p>
          }
          <ul>
            { this.state.invoiceData &&
              <li><span onClick={ () => this.getInvoices() } style={ this.state.load ? { opacity: '.6' } : {} }>{ this.state.load ? 'Пожалуйста, ожидайте..' : 'Скачать счет на оплату' }</span></li>
            }
            <li><span onClick={ () => this.getLink() }>Оплатить картой</span></li>
            <li><span onClick={ () => this.props.onCloseClick() }>Отмена</span></li>
          </ul>
          { !this.props.user &&
            <p className={ styles.notice }>Вам необходимо пройти регистрацию!</p>
          }
        </div>
      )
    }

    return (
      <div className={ styles.sub }>
        <input type="text" placeholder="Ваше имя" />
        <input type="email" placeholder="E-mail" />
        <input type="text" placeholder="+7 (xxx) xxx-xx-xx" />
        <p>Указывая свои данные вы даёте согласие на обработку персональных данных, в соответствии с политикой конфиденциальности</p>
        <ul>
          <li><span>Перезвоните мне</span></li>
          <li><span onClick={ () => this.props.onCloseClick() }>Отмена</span></li>
        </ul>
      </div>
    )
  }
}

export default connect(
  state => ({
    user: state.auth.user
  }),
  { getHalykLink, getInvoice }
)(SubscribeModal);
